<template>
  <div>
    <DataServiceManagementSuper v-if="userInfo.role[0]==1 || userInfo.role[0]==3"></DataServiceManagementSuper>
    <DataServiceManagementOrdinary v-if="userInfo.role[0]==2"></DataServiceManagementOrdinary>
  </div>
</template>

<script>
import DataServiceManagementSuper from "@/components/DataServiceManagementSuper"
import DataServiceManagementOrdinary from "@/components/DataServiceManagementOrdinary"
export default {
  name: 'UserManagement',
  data () {
    return {
      userInfo:JSON.parse(localStorage.getItem('UserInfo')),
    }
  },
  mounted () {
    var _this=this;
  },
  methods:{
  },
  components:{
    DataServiceManagementSuper:DataServiceManagementSuper,
    DataServiceManagementOrdinary:DataServiceManagementOrdinary
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  
</style>



// WEBPACK FOOTER //
// src/components/DataServiceManagement.vue